import {Controller} from "@/controllers/Controller";

/**
 * Controller for purchase API (ms-purchase)
 */
export class PurchaseController extends Controller {

    // Achats enrichis (nom du fournisseur, reste à payer, retard...), avec filtres, tris et pagination
    static getTable(urlParams = "") {
        return this.requestBuilder("GET", `/purchase/purchases/table${urlParams}`, true);
    }

    static getBySupplier(supplierId) {
        return this.requestBuilder("GET", `/purchase/purchases/by-supplier/${supplierId}`, true);
    }

    static getByOrder(orderId) {
        return this.requestBuilder("GET", `/purchase/purchases/by-order/${orderId}`, true);
    }

    // Avoirs fournisseurs d'une facture
    static getByInvoice(invoiceId) {
        return this.requestBuilder("GET", `/purchase/purchases/by-invoice/${invoiceId}`, true);
    }

    static get(id) {
        return this.requestBuilder("GET", `/purchase/purchases/${id}`, true);
    }

    static post(body) {
        return this.requestBuilder("POST", `/purchase/purchases`, true, body);
    }

    static patch(id, body) {
        return this.requestBuilder("PATCH", `/purchase/purchases/${id}`, true, body);
    }

    // Un achat à vérifier (facture reçue) devient un achat à payer
    static validate(id) {
        return this.requestBuilder("PATCH", `/purchase/purchases/validate/${id}`, true);
    }

    static delete(id) {
        return this.requestBuilder("PATCH", `/purchase/purchases/deactivate/${id}`, true);
    }

    // Crée les achats à vérifier des factures reçues (ms-invoice-transmission) pas encore importées
    static importIncomingInvoices(refresh = true) {
        return this.requestBuilder("POST", `/purchase/purchases/import-incoming-invoices`, true, {refresh});
    }
}
